const tableConfigProps = {
    emptyStateText: 'Nie udało się załadować danych',
    isLoading: false,
};

export const INSTALLMENTS_MODAL_CONFIG = {
    title: 'Koszty spłaty w ratach',
    subtitle:
        'Poniżej znajdziesz warunki spłaty dla różnych kwot transakcji po 30 dniach od dokonania zakupu.',
    tables: [
        {
            id: 1,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '10,00 zł - 499,99 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '4' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '15%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '97,9%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 2,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '500,00 zł - 799,99 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '5' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '17%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '90,1%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 3,
            tableProps: {
                emptyStateText: 'Nie udało się załadować danych',
                isLoading: false,
                columns: [
                    {
                        field: 'amount',
                        label: '800,00 zł - 1499,99 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '6' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '19%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '84,5%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 4,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '1500,00 zł - 2499,00 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '7' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '18%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '66,6%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 5,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '2500,00 zł - 3499,00 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '8' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '18%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '50,2%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 6,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '3500,00 zł - 6000,00 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '9' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '14%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '38,1%' },
                        ],
                    },
                ],
            },
        },
    ],
};
